const ComparerButton = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.14645 2.14645C2.34171 1.95118 2.65829 1.95118 2.85355 2.14645L3.67678 2.96967C3.96967 3.26256 3.96967 3.73744 3.67678 4.03033L2.85355 4.85355C2.65829 5.04882 2.34171 5.04882 2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L2.79289 3.5L2.14645 2.85355C1.95118 2.65829 1.95118 2.34171 2.14645 2.14645Z"
        fill="currentColor"
      />
      <path
        d="M4 5C4 4.72386 4.22386 4.5 4.5 4.5H5.5C5.77614 4.5 6 4.72386 6 5C6 5.27614 5.77614 5.5 5.5 5.5H4.5C4.22386 5.5 4 5.27614 4 5Z"
        fill="currentColor"
      />
      <path
        d="M10.3536 2.14645C10.1583 1.95118 9.84171 1.95118 9.64645 2.14645C9.45118 2.34171 9.45118 2.65829 9.64645 2.85355L10.2929 3.5L9.64645 4.14645C9.45118 4.34171 9.45118 4.65829 9.64645 4.85355C9.84171 5.04882 10.1583 5.04882 10.3536 4.85355L11.1768 4.03033C11.4697 3.73744 11.4697 3.26256 11.1768 2.96967L10.3536 2.14645Z"
        fill="currentColor"
      />
      <path
        d="M12 4.5C11.7239 4.5 11.5 4.72386 11.5 5C11.5 5.27614 11.7239 5.5 12 5.5H13C13.2761 5.5 13.5 5.27614 13.5 5C13.5 4.72386 13.2761 4.5 13 4.5H12Z"
        fill="currentColor"
      />
      <path
        d="M0 2C0 0.895431 0.89543 0 2 0H14C15.1046 0 16 0.895431 16 2V12C16 13.1046 15.1046 14 14 14H2C0.89543 14 0 13.1046 0 12V2ZM2 1C1.44772 1 1 1.44772 1 2V12C1 12.5523 1.44772 13 2 13H7.5V1H2ZM8.5 1V13H14C14.5523 13 15 12.5523 15 12V2C15 1.44772 14.5523 1 14 1H8.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ComparerButton;
